import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout'
import messages from '../../../locale/messages';
import ChatMessage from './ChatMessage';
import { restrictUrls } from '../../../helpers/adminPrivileges';

function action({ store, params, intl }) {
    const title = intl.formatMessage(messages.chatMessageLabel);

    //From Redux Store
    let isAdminAuthenticated = store?.getState()?.runtime.isAdminAuthenticated;
    let adminPrivileges = store?.getState()?.account.privileges;
    let privileges =  store?.getState()?.commonSettings.privileges;

    if (!isAdminAuthenticated) {
        return { redirect: '/login' }
    }

    if (!restrictUrls('/siteadmin/jobs', adminPrivileges, privileges)) {
        return { redirect: '/siteadmin' };
    }

    const bookingId = Number(params.id)
    const from = params.from;

    return {
        title,
        component: (
            <AdminLayout>
                <ChatMessage bookingId={bookingId} from={from} />
            </AdminLayout>
        ),
    }
}

export default action;